import { CircularProgress } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { MyChartDataTable } from "../../charts/MyChartDataTable";
import { Alert } from "../../components/MySnackToast";
import { CardKPI } from "../dashboard/CardKPI";
import { DashPanel } from "../dashboard/DashPanel";
import { AReceberVendaPrazo } from "./models";
import { PanelClientesEmAtraso } from "./PanelClientesEmAtraso";
import { useApi } from "../../components/api";

export const FinanceiroPage = () => {

  const { api } = useApi();

  const [data, setData] = useState<AReceberVendaPrazo | undefined>(undefined);

  useEffect(() => {
    const dataRef = new Date()
      .toISOString()
      .substring(0, 10);
    // const dataRef = '2022-08-01';

    api.get<AReceberVendaPrazo>('faturas/areceber?dataRef=' + dataRef).then(x => {
      setData(x.data);
    });

  }, [api]);

  if (!data)
    return <div style={{ marginTop: '100px', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <CircularProgress color="secondary" />
      <p>Aguarde, obtendo dados...</p>
    </div>;

  return (
    <div>
      <Alert severity="info">
        <span >Baseado no Contas a Receber de Vendas a Prazo nos respectivos periodos. Juros não inclusos.</span>
      </Alert>

      <Container maxWidth={false} style={{ paddingTop: '12px', paddingBottom: '20px' }}>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={6}
          >
            <CardKPI
              nome={"Faturamento Atual " + data.faturamentoAtual.competencia}
              indicador={{ valor: data.faturamentoAtual.total, formatacao: ",0", prefixo: "R$" }}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={6}
          >
            <CardKPI
              nome={"Próximo Faturamento " + data.proximoFaturamento.competencia}
              indicador={{ valor: data.proximoFaturamento.total, formatacao: ",0", prefixo: "R$" }}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={6}
          >
            <CardKPI
              nome={"Faturamento Anterior " + data.faturamentoAnterior.competencia}
              indicador={{ valor: data.faturamentoAnterior.total, formatacao: ",0", prefixo: "R$" }}
            />
          </Grid>
          <Grid
            item
            lg={3}
            sm={6}
            xl={3}
            xs={6}
          >
            <CardKPI
              nome={"Pendência Fat. Anterior " + data.faturamentoAnterior.competencia}
              indicador={{ valor: data.faturamentoAnterior.pendente, formatacao: ",0", prefixo: "R$" }}
            />
          </Grid>

          <Grid
            item
            lg={4}
            md={6}
            xl={4}
            xs={12}
          >

            <PanelClientesEmAtraso {...data} />

          </Grid>

          <Grid
            item
            lg={4}
            md={6}
            xl={4}
            xs={12}
          >
            <DashPanel title="Top 10 Clientes Fat. Atual">
              <MyChartDataTable rows={data.faturamentoAtual.top10Clientes.map(x => ({ name: x.nome, value: x.total }))} format=",0.00" prefix="R$" />
            </DashPanel>

          </Grid>
        </Grid>
      </Container>

    </div >
  );
};